export default __webpack_public_path__ + "static/image9-6aa062118675d9270c2f7e9967311166.jpeg";